import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { Router } from "@angular/router";
import Swal from "sweetalert2";

import { Global } from "../../global";
import { ApiService } from "../../service/apiServices";
import { AuthService } from "../../service/auth/auth.service";
import * as moment from "moment";
import { Modal } from "bootstrap";
@Component({
  selector: "app-painel-chamada",
  templateUrl: "./painel-chamada.component.html",
  styleUrls: ["./painel-chamada.component.css"],
  encapsulation: ViewEncapsulation.None,
})
export class PainelChamadaComponent implements OnInit {
  ListaAtendimento: any = [];
  filtroAguardandoAtendimento: any = "";
  filtroAtendido: any = "";
  dados = JSON.parse(localStorage.getItem("dadosPresencaUser"));
  presenca_com_inie = JSON.parse(
    localStorage.getItem("@DigtVentry:presencaUser")
  );
  usuario: any = {};
  presenca: any;

  tipoAtendimento: any = 0;
  tipoServico: any = 0;
  listTiposServicos: any = [];
  ine: boolean = false;

  listaAtendimentos: any = [];
  listaAtendimentosFiltrados: any = [];
  listaHistoricoAtendimentos: any = [];

  private ws: any;
  private reconnectTimeout: any = null;
  private reconnectIntervalMs = 5000;
  modaHistorico: any;
  detalheHistorico: any = null;
  itemDetalheExpandido: any = null;

  constructor(
    public service: ApiService,
    private global: Global,
    private router: Router,
    private authService: AuthService
  ) {
    this.authService.currentUser.subscribe((res) => {
      if (res) {
        this.usuario = res;
      }
    });

    this.authService.currentPresenca.subscribe((res) => {
      if (res) {
        this.presenca = res;
      }
    });

    if (!this.dados) {
      this.authService.logoutUser();
    }
  }

  ngOnInit() {
    this.obterEnumeradoresTipoServicoEsus();
    this.conectarWebSocket();
  }

  ngOnDestroy(): void {
    this.desconectarWebSocket();
  }

  obterEnumeradoresTipoServicoEsus() {
    this.service
      .Get(`Enumeradores/TipoServicoEsus`)
      .then((res) => {
        Swal.close();
        this.listTiposServicos = res;
      })
      .catch((res) => {
        if (res.status == 401 || res.error.status == 401) {
          Swal.close();
          this.authService.logoutUser();
        }
        Swal.close();
        Swal.fire("Erro", `${res.error.erros[0].messagem}`, "error");
      });
  }

  getWebSocketUrl(path: string): string {
    let baseUrl = this.global.apiUrl;

    // Remove qualquer barra final da URL base
    baseUrl = baseUrl.replace(/\/+$/, "");

    // Substitui protocolo
    if (baseUrl.startsWith("https://")) {
      baseUrl = baseUrl.replace("https://", "wss://");
    } else if (baseUrl.startsWith("http://")) {
      baseUrl = baseUrl.replace("http://", "ws://");
    }

    return `${baseUrl}${path}`;
  }

  conectarWebSocket(): void {
    const url = this.getWebSocketUrl("/ws/atendimento"); // substitua pela URL real
    this.ws = new WebSocket(url);

    this.ws.onopen = () => {
      const mensagemLogin = {
        $type: "WebSocketManager.Common.Message",
        messageType: 0,
        data: {
          login: this.presenca.usuario_cpf,
          cnes: this.presenca.estabelecimento_cnes,
        },
      };

      this.ws.send(JSON.stringify(mensagemLogin));
    };

    this.ws.onmessage = (event) => {
      const response: any = JSON.parse(event.data);

      if (
        response.messageType === 1 &&
        response.data &&
        response.data.$values
      ) {
        this.listaAtendimentos = response.data.$values;

        this.aplicarFiltros();
      }
    };

    this.ws.onerror = (error) => {
      console.error("WebSocket erro:", error);
      this.reconectarWebSocket();
    };

    this.ws.onclose = () => {
      console.warn("WebSocket desconectado.");
      this.reconectarWebSocket();
    };
  }

  aplicarFiltros(): void {
    const tipoServicoNum = parseInt(this.tipoServico as any, 10); // garante número

    this.listaAtendimentosFiltrados = this.listaAtendimentos.filter(
      (item: any) => {
        const filtroProfissional =
          this.tipoAtendimento === 0 ||
          item.profissional_cpf === this.presenca.usuario_cpf;

        const filtroServico =
          tipoServicoNum === 0 ||
          (item.enum_tipo_servico &&
            item.enum_tipo_servico.valor === tipoServicoNum);

        return filtroProfissional && filtroServico;
      }
    );

    if (this.ine) {
      this.listaAtendimentosFiltrados = this.listaAtendimentosFiltrados.filter(
        (item: any) => {
          return item.equipe_ine === this.presenca_com_inie.ocupacao_ine;
        }
      );
    }
  }

  reconectarWebSocket(): void {
    if (this.reconnectTimeout) {
      clearTimeout(this.reconnectTimeout);
    }

    this.reconnectTimeout = setTimeout(() => {
      this.conectarWebSocket();
    }, this.reconnectIntervalMs);
  }

  desconectarWebSocket(): void {
    if (this.ws) {
      this.ws.close();
      this.ws = null;
    }

    if (this.reconnectTimeout) {
      clearTimeout(this.reconnectTimeout);
      this.reconnectTimeout = null;
    }
  }

  iniciarAtendimento(item: any): void {
    // Aqui você pode chamar uma API, enviar no socket, etc.
    var obj = {
      codigo_atendimento: item.codigo_atendimento,
      sala_id: this.presenca.sala_id,
      usuario_id: this.presenca.usuario_id,
    };
    Swal.fire("Favor aguarde");
    Swal.showLoading();

    this.service
      .Post(`ChamadaPainel`, obj)
      .then((res) => {
        Swal.close();
        Swal.fire({
          icon: "success",
          title: "Sucesso!",
          html: "Sucesso ao chamar!",
        }).then((result) => {
          if (result.isConfirmed) {
          }
        });
      })
      .catch((res) => {
        if (res.status == 401 || res.error.status == 401) {
          Swal.close();
          this.authService.logoutUser();
        }
        Swal.close();
        Swal.fire("Erro", `${res.error.erros[0].messagem}`, "error");
      });
  }
  changeStatus = () => {
    this.ine = !this.ine;
    this.aplicarFiltros();
  };
  buscarHistoricoAtendimento(cpf?: string, cns?: string) {
    if (cpf == null && cns == null) {
      Swal.fire({
        icon: "error",
        title: "Erro",
        html: "CPF ou CNS do paciente são necessários para buscar o histórico de atendimento!",
      });
      return;
    }

    var url = `Esus/Atendimento`;

    if (cpf !== undefined && cpf !== null && cpf.trim() !== "") {
      url += `?cpf=${cpf}`;
    }
    if (cns !== undefined && cns !== null && cns.trim() !== "") {
      url += `${cpf && cpf.trim() !== "" ? "&" : "?"}cns=${cns}`;
    }

    this.service
      .Get(url)
      .then((res) => {
        Swal.close();
        this.listaHistoricoAtendimentos = res;
        const modalEl = document.getElementById("modalHistorico");
        this.modaHistorico = new Modal(modalEl!); // SALVA A INSTÂNCIA
        this.modaHistorico.show();
      })
      .catch((res) => {
        if (res.status == 401 || res.error.status == 401) {
          Swal.close();
          this.authService.logoutUser();
        }
        Swal.close();
        Swal.fire({
          icon: "error",
          title: "Erro",
          html: "Um erro ocorreu ao buscar o histórico de atendimentos!",
        }).then((result) => {
          if (result.isConfirmed) {
          }
        });
      });
  }
  abrirModal(item: any) {
    this.buscarHistoricoAtendimento(item.paciente_cpf, item.paciente_cns);
  }
  fecharModal() {
    if (this.modaHistorico) {
      this.modaHistorico.hide(); // AQUI FUNCIONA
    }
  }
  getCorTipo(tipo: string): string {
    const mapaCores: any = {
      CONSULTA: "#007bff",
      "CONSULTA ODONTOLÓGICA": "#0d6efd",
      "ESCUTA INICIAL": "#6610f2",
      OBSERVAÇÂO: "#6f42c1",
      "PRÉ-NATAL": "#d63384",
      PUERICULTURA: "#fd7e14",
      PUERPÉRIO: "#d63384",
      VACINAÇÃO: "#198754",
      "ZIKA / MICROCEFALIA": "#dc3545",
    };

    return mapaCores[tipo] || "#0dcaf0";
  }
  detalhes(itemHistorico: any, index: number) {
    var itemExpandido = null;    

    if (this.itemDetalheExpandido !== null) {
      itemExpandido =
        this.listaHistoricoAtendimentos[this.itemDetalheExpandido];
      itemExpandido.expandido = false;
    }

    this.itemDetalheExpandido = index;

    Swal.fire("Favor aguarde");
    Swal.showLoading();

    this.service
      .Get(
        `Esus/Atendimento/Detalhe?tb_atend_prof_id=${itemHistorico.tb_atend_prof_id}`
      )
      .then((res) => {
        itemHistorico.detalhes = res;
        itemHistorico.expandido = true;
        Swal.close();
      })
      .catch((res) => {
        if (res.status == 401 || res.error.status == 401) {
          Swal.close();
          this.authService.logoutUser();
        }
        Swal.close();
        Swal.fire({
          icon: "error",
          title: "Erro",
          html: "Um erro ocorreu ao buscar os detalhes do atendimento!",
        }).then((result) => {
          if (result.isConfirmed) {
          }
        });
      });
  }

  temDadosValidos(lista: any[]): boolean {
    if (!lista) return false;

    return lista.some(
      (x) =>
        x &&
        Object.keys(x).length > 0 &&
        Object.values(x).some((v) => v !== null && v !== undefined && v !== "")
    );
  }
}
